import api, { paginado } from './apiClient'

// ---------------------------------------------------------------- Produtos --

/** `GET /products?search&active&limit&offset` */
export const getProductAll = async (item = {}) => {
  const response = await api.get('/products', {
    params: { limit: item.limit, offset: item.offset, active: item.active },
  })
  return { data: paginado(response) }
}

export const searchProductService = async data => {
  const response = await api.get('/products', {
    params: {
      search: data.SearchWord || undefined,
      limit: data.limit,
      offset: data.offset,
      active: data.active,
    },
  })
  return { data: paginado(response) }
}

export const getUniqueProductService = async productId => api.get(`/products/${productId}`)

/**
 * `POST /products/conversion-factor` — o "Salvar" da tela de Fator de Conversão.
 *
 * Substitui o `Product/UpdatePieceList` do sistema antigo. É tudo ou nada: um
 * produto de outra empresa faz o lote inteiro voltar 404 sem gravar nada, em
 * vez de persistir metade e responder sucesso.
 */
export const setConversionFactor = async items =>
  api.post('/products/conversion-factor', { items })

export const createProductService = async product => api.post('/products', product)

/**
 * `POST /products/bulk` — carga de produtos em lote.
 *
 * Não aborta no primeiro erro: a resposta traz os contadores e `results` com o
 * desfecho de cada linha (`index` é a posição enviada), para a tela marcar
 * exatamente quais precisam de correção.
 */
export const createBulkProduct = async (items, aoDuplicar) =>
  api.post('/products/bulk', { items, aoDuplicar })

export const editProductService = async product => {
  const { productId, ...corpo } = product
  return api.patch(`/products/${productId}`, corpo)
}

export const deleteProductService = async productId => api.delete(`/products/${productId}`)

// ---------------------------------------------------- Associação / Itens RFID

/** `GET /rfid-items?subCompanyId&search&status&productId&limit&offset` */
export const getProductAssociationService = async (limit, offset, subCompanyId) => {
  const response = await api.get('/rfid-items', { params: { subCompanyId, limit, offset } })
  return { data: paginado(response) }
}

export const getProductAssociationSearchService = async (
  limit,
  offset,
  subCompanyId,
  search,
  situation
) => {
  const response = await api.get('/rfid-items', {
    params: {
      subCompanyId,
      limit,
      offset,
      search: search || undefined,
      // Valor do enum (`CRIADO`, `IMPRESSO`, …); qualquer outra coisa devolve 400.
      situation: situation || undefined,
    },
  })
  return { data: paginado(response) }
}

export const getUniqueProductAssociationService = async rfidItemId =>
  api.get(`/rfid-items/${rfidItemId}`)

/**
 * Etiquetas atreladas a uma ordem (ou a uma quebra específica).
 *
 * É o histórico de RFID da ordem: o vínculo é gravado pelo apontamento de chão
 * de fábrica (`POST /shopfloor/tag-association`), então ordem sem apontamento
 * devolve lista vazia — não é erro.
 */
export const getRfidItemsByOrder = async ({ orderId, breakId, limit = 200, offset = 0 }) => {
  const response = await api.get('/rfid-items', {
    params: { orderId, breakId: breakId || undefined, limit, offset },
  })
  return { data: paginado(response) }
}

/** `GET /rfid-items/by-epc/{epc}` — rastreamento (Épico 04). */
export const getProductItensRfid = async (subCompanyId, epc) =>
  api.get(`/rfid-items/by-epc/${encodeURIComponent(epc)}`, { params: { subCompanyId } })

/** `GET /rfid-items/by-epc/{epc}/timeline` — linha do tempo (Épico 08). */
export const getRfidItemTimeline = async epc => {
  const response = await api.get(`/rfid-items/by-epc/${encodeURIComponent(epc)}/timeline`)
  const eventos = Array.isArray(response.data) ? response.data : response.data?.items || []
  return { data: { result: eventos, total: eventos.length } }
}

export const createProductAssociationService = async association =>
  api.post('/rfid-items', association)

export const editProductAssociationService = async association => {
  const { rfidItemId, ...corpo } = association
  return api.patch(`/rfid-items/${rfidItemId}`, corpo)
}

export const deleteProductAssociationService = async rfidItemId =>
  api.delete(`/rfid-items/${rfidItemId}`)

/** `POST /rfid-items/{id}/lock` — bloqueio com justificativa. */
export const updateLockService = async data =>
  api.post(`/rfid-items/${data.rfidItemId}/lock`, {
    locked: data.lock,
    justification: data.justification,
  })
